import { Link } from 'react-router-dom';

const CtaSection = () => {
  return (
    <section className="relative py-28 overflow-hidden bg-ea-black">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/011a6795fa091858fa7956ececb854b7.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ea-blue-dark/40 via-ea-black to-ea-blue-dark/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ea-blue/10 border border-ea-blue/30 mb-7">
          <span className="w-1.5 h-1.5 rounded-full bg-ea-blue animate-pulse-slow"></span>
          <span className="text-ea-blue text-xs font-medium uppercase tracking-wider">Ready to Automate?</span>
        </div>

        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Automate<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-ea-blue to-ea-blue-electric">
            Your Business?
          </span>
        </h2>

        <p className="text-ea-gray text-lg lg:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Join businesses already using AI automation to save time, book more clients, and grow faster. Book your free demo call today.
        </p>

        {/* Four plans strip */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-10 max-w-2xl mx-auto">
          {[
            { name: 'Starter', price: '£149', desc: 'Lead Capture' },
            { name: 'Pro', price: '£299', desc: 'Sales & Booking', popular: true },
            { name: 'Scale', price: '£599', desc: 'Full OS' },
            { name: 'Custom', price: '£799+', desc: 'Bespoke' },
          ].map((plan) => (
            <Link
              key={plan.name}
              to="/pricing"
              className={`relative flex flex-col items-center py-4 px-3 rounded-xl border transition-all duration-200 cursor-pointer group ${
                plan.popular
                  ? 'bg-ea-blue/10 border-ea-blue/40'
                  : 'bg-white/[0.03] border-white/10 hover:border-ea-blue/30'
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-ea-blue text-white rounded-full whitespace-nowrap" style={{ fontSize: '9px', fontWeight: 700 }}>
                  Most Popular
                </span>
              )}
              <p className={`text-xs font-semibold mb-1 ${plan.popular ? 'text-ea-blue' : 'text-ea-gray group-hover:text-white transition-colors'}`}>{plan.name}</p>
              <p className="text-white font-bold text-lg leading-none mb-1">{plan.price}</p>
              <p className="text-ea-gray/60 text-[10px]">/mo &bull; {plan.desc}</p>
            </Link>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-4 bg-ea-blue hover:bg-ea-blue-light text-white font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 text-base"
            style={{ boxShadow: '0 0 30px rgba(14, 165, 233, 0.4)' }}
          >
            Book Your Free Demo <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/pricing"
            className="px-8 py-4 border border-white/20 hover:border-ea-blue text-white/80 hover:text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
          >
            View All Plans
          </Link>
        </div>

        <p className="text-ea-gray/60 text-sm mt-8">No commitment required &bull; Free 30-minute strategy call &bull; 4 plans from £149/mo</p>
      </div>

      {/* Decorative watermark */}
      <div className="absolute bottom-4 left-0 right-0 text-center pointer-events-none overflow-hidden">
        <span className="text-8xl font-black text-white/[0.02] uppercase tracking-widest whitespace-nowrap">
          EVERYTHING AUTOMATION
        </span>
      </div>
    </section>
  );
};

export default CtaSection;
